import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Alert,
} from 'reactstrap';
import Select from 'react-select';

const PayLookupForm = ({
  selectedEmployee,
  onEmployeeChange,
  employees,
  selectedPeriod,
  onPeriodChange,
  payPeriods,
  submitting,
  onSubmit,
  errors,
}) => {
  return (
    <Container>
      <Row className="mb-4">
        <Col md={6}>
          <FormGroup>
            <Label for="siteSelect">Employee</Label>
            <Select
              name="siteSelect"
              value={selectedEmployee}
              onChange={onEmployeeChange}
              options={employees}
            />
            {errors.employee && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.site}
              </Alert>
            )}
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label for="siteSelect">Pay Period</Label>
            <Select
              name="siteSelect"
              value={selectedPeriod}
              onChange={onPeriodChange}
              options={payPeriods}
            />
            {errors.payPeriod && (
              <Alert className="mt-2 p-2" color={'danger'}>
                {errors.site}
              </Alert>
            )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <FormGroup>
            <Button
              color="primary"
              type="submit"
              disabled={submitting}
              onClick={onSubmit}
              className="mr-2"
            >
              {submitting ? 'Generating' : 'Generate Time Card'}
            </Button>
          </FormGroup>
        </Col>
      </Row>
    </Container>
  );
};

PayLookupForm.propTypes = {
  payPeriods: PropTypes.array.isRequired,
};

export default PayLookupForm;



// WEBPACK FOOTER //
// ./src/components/pay/PayLookupForm.js